<template>
<div id="app">
  <sidebar ref="sidebar">
  <div class="centertext">
  <i class="unhide huge icon"></i>
  <div>Hi, {{$getUser().name}}</div>
 
  </div>
  <div class="ui inverted divider"></div>
    <div class="ui vertical inverted menu">
      <a v-for="item in menuItems" class="item" :name="item.name" @click="$router.push(item.link)">
        <i :class="[item.icon]" class="icon" ></i> {{item.label}}
      </a>
    </div>
  </sidebar>

  <section id="header" class="ui equal width padded grid" v-if="['home','login','signup','thankyou'].indexOf(this.$router.currentRoute.name) === -1">
    <div class="row ui segment toolbar">
      <div class="column" style="padding-right:0;">

        <a @click="onHome()" style="margin-left: .1em;">
    
         <i class="unhide big icon green"></i><div class="logo">Restock<i class="registered icon"></i></div>
        </a>
    

      </div>
      <div class="right aligned column" style="padding-left:0;">
        <div v-if="!$isTokenExpired()">
     
       <div class="ui labeled tiny button" tabindex="0">
  <div class="ui grey tiny button" data-tooltip="Actions List" data-inverted="" data-position="left center" @click.stop="onMenu">
    <i class="windows icon"></i></div>
  <a class="ui grey basic label" data-tooltip="Sign Out" data-inverted="" data-position="left center" @click="onSignout">
    <i class="sign small out icon" style="font-size:1.2em;"></i></a>
</div>

        </div>
        <div v-if="$isTokenExpired()">
         <span style="letter-spacing: .07em; color: #767676">Already a customer?</span>
          <button class="ui grey tiny button" @click="$router.push('/login')" data-tooltip="Login to your account" data-inverted="" data-position="top right">LOG IN</button>
        </div>
      </div>
    </div>
  </section>

  <section id="contents">
      <router-view></router-view>
  </section>
  <constatus></constatus>
  <onerror></onerror>
</div>
</template>

<script>
'use strict';
export default {
  data() {
    return {
      menuItems: [],
        }
  },
  created() {
    if (!this.$isTokenExpired()) {
          this.setMenu();
    }

    this.$root.$on('onLogin', (e) => {
              this.setMenu();
              switch (this.$getUser().role) {
        case this.$userRoles.admin:
          this.$router.push({name: 'admin.customers'})
        break
case this.$userRoles.customer:
this.$router.push({name: 'customer.dashboard'})
break
case this.$userRoles.courier:
          this.$router.push({name: 'courier.customers'});
          break
              }
     
    })
  },

  destroyed() {
    this.$root.$off('onLogin')
  },
  methods: {
    onHome() {
   if (!this.$isAuth()) { this.$router.push('/') }
    },
    onMenu() {
      this.$refs.sidebar.toggle();
    },
    setMenu() {
      switch (this.$getUser().role) {
        case this.$userRoles.admin:
          this.menuItems = [{
              name: 'customers',
              link: '/admin/customers',
              label: 'Customers List',
              icon: 'users'
            }, {
              name: 'users',
              link: '/admin/users',
              label: 'Users List',
              icon: 'street view'
            }, {
              name: 'products',
              link: '/admin/products',
              label: 'Products List',
              icon: 'tags'
            },
            {
              name: 'stock',
              link: '/admin/stock',
              label: 'Stock in Hand',
              icon: 'barcode'
            },
            {
              name: 'restock',
              link: '/admin/Restock',
              label: 'Restock',
              icon: 'repeat'
            },
            {
              name: 'shipments',
              link: '/admin/shipments',
              label: 'Shipments',
              icon: 'shipping'
            }, 
            {
              name: 'invoices',
              link: '/admin/invoices',
              label: 'Customer Invoices',
              icon: 'file text outline'
            },
            {
              name: 'suppliers',
              link: '/admin/suppliers',
              label: 'Suppliers',
              icon: 'options'
            },
            {
              name: 'settings',
              link: '/admin/settings',
              label: 'Settings',
              icon: 'setting'
            },
              {
              name: 'tools',
              link: '/admin/tools',
              label: 'Tools',
              icon: 'configure'
            },

            
          ];
          
          break;
        case this.$userRoles.customer:
          this.menuItems = [
          {
              name: 'dashboard',
              link: '/customer/dashboard',
              label: 'Dashboard',
              icon: 'pie chart'
            },
            {
              name: 'marketplace',
              link: '/customer/marketplace',
              label: 'Marketplace',
              icon: 'tags'
            },
            {
              name: 'subscriptions',
              link: '/customer/subscriptions',
              label: 'Subscriptions',
              icon: 'unhide'
            }, {
              name: 'requestions',
              link: '/customer/requisitions',
              label: 'Requisitions',
              icon: 'payment'
            }, {
              name: 'purchaseorder',
              link: '/customer/orders',
              label: 'Purchase Order',
              icon: 'shop'
            },
             {
              name: 'invoices',
              link: '/customer/invoices',
              label: 'Invoices',
              icon: 'file text outline'
            }, {
              name: 'account',
              link: '/customer/account',
              label: 'Account',
              icon: 'user'
            }

          ];
          break;
        case this.$userRoles.courier:
              this.menuItems = [
                /*{
              name: 'shipments',
              link: '/courier/shipments',
              label: 'Pending Shipments ',
              icon: 'shipping'
      }, */
            {
              name: 'customerlist',
              link: '/courier/customers',
              label: 'Customer List',
              icon: 'users'
            }

          ];

          break;
        default:
    
      }
    }, // Set menu
    onSignout() {
      this.$logout()
      this.$router.push('/login')
    }

  }

}
</script>

<style>
#app {
  height: 100vh;
  overflow:auto;
}

.toolbar {
  background: #FFFFFF;
  color: #999ea4;
  align-items: center;
  width: 100%;
  border-radius: 0 !important;
  box-shadow: 0 4px 22px 0 rgba(0,0,0,0.1) !important;
  padding-top: .7em !important;
  padding-bottom: .7em !important;
}

.logo {
  display: inline;
  font-size: 1.8em;
  /*color: rgba(0, 0, 0, 0.87);*/
  color: #3c4e60 !important;
   vertical-align: middle;
}

.logo i {
  font-size: .5em;
  vertical-align: text-top;
} 
.toolbar a  {
  color: grey !important;
}

.toolbar a:hover  {
  color: #4183C4 !important;
}


#header {
  position: fixed;
  bottom: 0;
  z-index: 700;
  width: 100%;
  /*opacity: .94;*/
  background: linear-gradient(0deg, rgba(255,255,255,0), rgb(255,255,255) 1.875rem);
}

@media all and (min-width: 0) and (max-width: 480px) {
  .toolbar span {
    display: none;
  }
}

@media only screen and (min-width: 1200px) {

}

@media only screen and (max-width: 767px) {
}
</style>



// WEBPACK FOOTER //
// App.vue?892464c8